import { render, staticRenderFns } from "./SingleEvent.vue?vue&type=template&id=37ddf287&"
import script from "./SingleEvent.vue?vue&type=script&lang=js&"
export * from "./SingleEvent.vue?vue&type=script&lang=js&"
import style0 from "./SingleEvent.vue?vue&type=style&index=0&id=37ddf287&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports